/**
 * SIGFU REST API
 * Serveur d\'api en NodeJs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DepotLigneSource } from './depotLigneSource';
import { DepotLigneParty } from './depotLigneParty';
import { DepotLigneSpatialunit } from './depotLigneSpatialunit';


export interface DepotLigne { 
    idDepotLigne: number;
    username: string;
    applicationId: string;
    transactionId: string;
    transactionTypeName: string;
    transactionType: string;
    transactionNo: string;
    etat: number;
    montant: number;
    dateDepot: string;
    dateCreation: string;
    suId: string;
    suSuid: string;
    suSearchType: string;
    suSearchIlot: string;
    suSearchLotParcelle: string;
    suSearchDepartement: string;
    suSearchCirconscription: string;
    suSearchDesignation: string;
    parties: Array<DepotLigneParty>;
    sources: Array<DepotLigneSource>;
    spatialunits: Array<DepotLigneSpatialunit>;
    note: string;
    dossierType: string;
    stateReasonCode: string;
    stateAct: string;
    stateReasonId: string;
    recuPaiementId: string;
    recuPaiementFile: string;
    recuDepotFile: string;
    ordreRecetteFile: string;
    clickPaiement: boolean;
    lienRecu: string;
    isRecuEnvoye?: boolean;
}

